/* eslint-disable complexity */
/* eslint-disable no-restricted-imports */
/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import {
	CLICK_PRODUCT_VIEW_SOURCE,
	CLICK_SOURCE_LIST_NAME,
} from '@/data/constants/clickProductView';
import { GTMCarouselItemListViewPayload } from '@/data/types/GTM';
import { ProductType } from '@/data/types/Product';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import { extractPartNumberFather } from '@/data/utils/extractPartNumberFather';

export const buildCarouselItem = (
	product: ProductType,
	index: number,
	item_list_id: string,
	item_list_name: string,
	affiliation: 'Dportenis' | 'Dpstreet'
) => {
	const offer = product.productPrice?.offer ?? 0;
	const list = product.productPrice?.list ?? offer;
	const discount = list > offer ? list - offer : 0;

	return {
		item_id: product.partNumber,
		item_group_id: extractPartNumberFather(product.partNumber),
		item_name: product.name,
		item_brand:
			product.manufacturer ?? findProductAttribute(product.attributes, 'Marca')?.value ?? '',
		item_category: findProductAttribute(product.attributes, 'Genero')?.value ?? '',
		item_category2: findProductAttribute(product.attributes, 'Familia')?.value ?? '',
		item_category3: findProductAttribute(product.attributes, 'Uso')?.value ?? '',
		price: offer,
		discount,
		item_color: findProductAttribute(product.attributes, 'Color1')?.value ?? '',
		item_tipo_precio: discount > 0 ? 'Oferta' : 'Full price',
		index: index + 1,
		item_list_id,
		item_list_name,
		affiliation,
		item_ribbons: mergeRibbonsForProduct(product.ribbons).flatMap((r) => r.value),
	};
};

export const getGTMCarouselItemListViewEventData = async (
	payload: GTMCarouselItemListViewPayload
) => {
	const { parentProduct, parentPartNumber, products, item_list_id } = payload;

	const item_list_name =
		CLICK_SOURCE_LIST_NAME[item_list_id as CLICK_PRODUCT_VIEW_SOURCE] ?? item_list_id;

	const parent =
		parentProduct ??
		(parentPartNumber ? products.find((p) => p.partNumber === parentPartNumber) : undefined);
	const listProducts = parent
		? products.filter((p) => p.partNumber !== parent.partNumber)
		: products;

	return {
		product_item_id: parent?.partNumber ?? parentPartNumber ?? '',
		product_item_name: parent?.name ?? '',
		familia_producto: (parent && findProductAttribute(parent.attributes, 'Familia')?.value) ?? '',
		ecommerce: {
			item_list_id,
			item_list_name,
			items: listProducts.map((product, idx) =>
				buildCarouselItem(product, idx, item_list_id, item_list_name, 'Dportenis')
			),
		},
	};
};
